var IconSize = /* @__PURE__ */ ((IconSize2) => {
  IconSize2[IconSize2["XXSmall"] = 24] = "XXSmall";
  IconSize2[IconSize2["XSmall"] = 38] = "XSmall";
  IconSize2[IconSize2["Small"] = 48] = "Small";
  IconSize2[IconSize2["Medium"] = 64] = "Medium";
  IconSize2[IconSize2["Large"] = 80] = "Large";
  IconSize2[IconSize2["XLarge"] = 130] = "XLarge";
  return IconSize2;
})(IconSize || {});
var ZIndex = /* @__PURE__ */ ((ZIndex2) => {
  ZIndex2[ZIndex2["Modal"] = 13e5] = "Modal";
  ZIndex2[ZIndex2["PopOver"] = 11e3] = "PopOver";
  ZIndex2[ZIndex2["ExpanderTrigger"] = 1e4] = "ExpanderTrigger";
  ZIndex2[ZIndex2["OverlayScreen"] = 9999] = "OverlayScreen";
  ZIndex2[ZIndex2["LightBoxButtons"] = 1e3] = "LightBoxButtons";
  return ZIndex2;
})(ZIndex || {});
const AVERAGE_CHARACTER_WIDTH_PX = 12;
var FormOnColor = /* @__PURE__ */ ((FormOnColor2) => {
  FormOnColor2["onwhite"] = "onwhite";
  FormOnColor2["ongrey"] = "ongrey";
  FormOnColor2["onblueberry"] = "onblueberry";
  FormOnColor2["ondark"] = "ondark";
  FormOnColor2["oninvalid"] = "oninvalid";
  return FormOnColor2;
})(FormOnColor || {});
var FormSize = /* @__PURE__ */ ((FormSize2) => {
  FormSize2["medium"] = "medium";
  FormSize2["large"] = "large";
  return FormSize2;
})(FormSize || {});
var AnalyticsId = /* @__PURE__ */ ((AnalyticsId2) => {
  AnalyticsId2["AnchorLink"] = "anchor-link";
  AnalyticsId2["Avatar"] = "avatar";
  AnalyticsId2["Badge"] = "badge";
  AnalyticsId2["Button"] = "button";
  AnalyticsId2["Checkbox"] = "checkbox";
  AnalyticsId2["Chip"] = "chip";
  AnalyticsId2["Close"] = "close";
  AnalyticsId2["DictionaryTrigger"] = "dictionary-trigger";
  AnalyticsId2["Dropdown"] = "dropdown";
  AnalyticsId2["Duolist"] = "duolist";
  AnalyticsId2["EmptyState"] = "empty-state";
  AnalyticsId2["Expander"] = "expander";
  AnalyticsId2["ExpanderHierarchy"] = "expander-hierarchy";
  AnalyticsId2["ExpanderHierarchyExpander"] = "expander-hierarchy-expander";
  AnalyticsId2["ExpanderList"] = "expander-list";
  AnalyticsId2["ExpanderListExpander"] = "expander-list-expander";
  AnalyticsId2["EyebrowHeader"] = "eyebrow-header";
  AnalyticsId2["FormGroup"] = "form-group";
  AnalyticsId2["FormLayout"] = "form-layout";
  AnalyticsId2["HelpBubble"] = "help-bubble";
  AnalyticsId2["HelpQuestion"] = "help-question";
  AnalyticsId2["HighlightPanel"] = "highlight-panel";
  AnalyticsId2["Icon"] = "icon";
  AnalyticsId2["Illustration"] = "Illustration";
  AnalyticsId2["Input"] = "input";
  AnalyticsId2["Label"] = "label";
  AnalyticsId2["Link"] = "link";
  AnalyticsId2["LinkList"] = "link-list";
  AnalyticsId2["List"] = "list";
  AnalyticsId2["Loader"] = "loader";
  AnalyticsId2["Logo"] = "logo";
  AnalyticsId2["Modal"] = "modal";
  AnalyticsId2["NotificationPanel"] = "notification-panel";
  AnalyticsId2["Panel"] = "panel";
  AnalyticsId2["PanelList"] = "panel-list";
  AnalyticsId2["PopMenu"] = "pop-menu";
  AnalyticsId2["PopOver"] = "pop-over";
  AnalyticsId2["Portal"] = "portal";
  AnalyticsId2["PromoPanel"] = "promo-panel";
  AnalyticsId2["RadioButton"] = "radio-button";
  AnalyticsId2["Select"] = "select";
  AnalyticsId2["SharingStatus"] = "sharing-status";
  AnalyticsId2["Slider"] = "slider";
  AnalyticsId2["Spacer"] = "spacer";
  AnalyticsId2["StatusDot"] = "status-dot";
  AnalyticsId2["Step"] = "step";
  AnalyticsId2["StepButtons"] = "step-buttons";
  AnalyticsId2["Stepper"] = "stepper";
  AnalyticsId2["Sublabel"] = "sublabel";
  AnalyticsId2["Table"] = "table";
  AnalyticsId2["Tag"] = "tag";
  AnalyticsId2["TagList"] = "tag-list";
  AnalyticsId2["Textarea"] = "textarea";
  AnalyticsId2["Tile"] = "tile";
  AnalyticsId2["Title"] = "title";
  AnalyticsId2["Toggle"] = "toggle";
  AnalyticsId2["Tooltip"] = "tooltip";
  AnalyticsId2["Trigger"] = "trigger";
  AnalyticsId2["Validation"] = "validation";
  return AnalyticsId2;
})(AnalyticsId || {});
var KeyboardEventKey = /* @__PURE__ */ ((KeyboardEventKey2) => {
  KeyboardEventKey2["Enter"] = "Enter";
  KeyboardEventKey2["Escape"] = "Escape";
  KeyboardEventKey2["ArrowDown"] = "ArrowDown";
  KeyboardEventKey2["ArrowUp"] = "ArrowUp";
  KeyboardEventKey2["ArrowRight"] = "ArrowRight";
  KeyboardEventKey2["ArrowLeft"] = "ArrowLeft";
  KeyboardEventKey2["Home"] = "Home";
  KeyboardEventKey2["End"] = "End";
  KeyboardEventKey2["Space"] = " ";
  KeyboardEventKey2["Tab"] = "Tab";
  return KeyboardEventKey2;
})(KeyboardEventKey || {});
export {
  AVERAGE_CHARACTER_WIDTH_PX,
  AnalyticsId,
  FormOnColor,
  FormSize,
  IconSize,
  KeyboardEventKey,
  ZIndex
};
//# sourceMappingURL=constants.js.map
